import { findKey } from 'lodash';

import { PathNames } from './routingPath';

export const MAIN_PAGE_TITLE = 'Talentprofile.net';

export enum PageTitles {
  ACCOUNT = 'Account',
  ADMIN_COMPANIES = 'Companies administration',
  ADMIN_COMPANY = 'Company administration',
  ADMIN_FEATURE_FLAGS = 'Feature Flags administration',
  ADMIN_JOB_ADS = 'Job Ads administration',
  ADMIN_JOB_APPLICATIONS = 'Job Applications administration',
  ADMIN_QUIZZES = 'Quizzes administration',
  ADMIN_TALENT_SEARCH = 'Talent Search administration',
  ADMIN_TALENTS = 'Talents administration',
  ADMIN_USERS = 'Users administration',
  COMPANY_BILLING = 'Company Billing',
  COMPANY_CREATE = 'Create Company',
  COMPANY_CREATE_SUCCESS = 'Create Company Success',
  COMPANY_DASHBOARD = 'Company Dashboard',
  COMPANY_INVOICING = 'Company Invoicing',
  COMPANY_JOB_AD = 'Company Job Ad',
  COMPANY_JOB_AD_CREATE = 'Company Create Job Ad',
  COMPANY_JOB_AD_EDIT = 'Company Edit Job Ad',
  COMPANY_JOB_ADS = 'Company Job Ads',
  COMPANY_JOB_DESCRIPTION = 'Company Job Description',
  COMPANY_JOB_DESCRIPTION_CREATE = 'Company Create Job Description',
  COMPANY_JOB_DESCRIPTION_EDIT = 'Company Edit Job Description',
  COMPANY_JOB_DESCRIPTIONS = 'Company Job Descriptions',
  COMPANY_MEMBERS = 'Company Members',
  COMPANY_MY_COMPANIES = 'Company My Companies',
  COMPANY_PROFILE = 'Company Profile',
  COMPANY_RECEIVED_JOB_APPLICATION = 'Company Received Job Application',
  COMPANY_RECEIVED_JOB_APPLICATIONS = 'Company Received Job Applications',
  COMPANY_ROLES = 'Company Roles',
  COMPANY_SALES = 'Company Sales',
  COMPANY_SENT_INVITATION = 'Company Sent Invitation',
  COMPANY_SENT_INVITATIONS = 'Company Sent Invitations',
  COMPANY_TALENT_ASSIGNMENT = 'Company Talent Assignment',
  COMPANY_TALENT_ASSIGNMENT_CREATE = 'Company Create Talent Assignment',
  COMPANY_TALENT_ASSIGNMENT_EDIT = 'Company Edit Talent Assignment',
  COMPANY_TALENT_ASSIGNMENTS = 'Company Talent Assignments',
  COMPANY_TALENT_INVITE = 'Talent Invite',
  COMPANY_TALENT_INVITE_FORM = 'Talent Invite',
  COMPANY_TALENT_INVITE_SUCCESS = 'Invite Success',
  COMPANY_TALENT_ROSTER = 'Company Talent Roster',
  COMPANY_TALENT_ROSTER_DETAILS = 'Company Talent Roster Details',
  COMPANY_TALENT_SAVED = 'Company Saved Talents',
  COMPANY_TRANSACTIONS = 'Company Transactions',
  EDIT_USER_ACCOUNT = 'Edit User Account',
  ERROR = 'Error',
  FORGOT_PASSWORD = 'Forgot password',
  HOMEPAGE = '',
  IMPERSONATE = 'Impersonate',
  JOB_APPLY = 'Apply to a job',
  JOB_APPLY_FORM = 'Send job application',
  JOB_APPLY_SUCCESS = 'Job application sent',
  JOB_SEARCH = 'Job Search',
  SIGN_IN = 'Sign in',
  SIGN_UP = 'Sign up',
  SIGN_UP_SUCCESS = 'Sign up successful',
  SITE_SETTINGS = 'Site Settings',
  TALENT_APPLIED_JOBS = 'Talent Applied Jobs',
  TALENT_ASSIGNMENT = 'Talent Job Assignment',
  TALENT_ASSIGNMENT_CREATE = 'Talent Create Job Assignment',
  TALENT_ASSIGNMENT_EDIT = 'Talent Edit Job Assignment',
  TALENT_ASSIGNMENTS = 'Talent Job Assignments',
  TALENT_BILLING = 'Talent Billing',
  TALENT_COMPANY = 'Talent Company',
  TALENT_DASHBOARD = 'Talent Dashboard',
  TALENT_EMPLOYERS = 'Talent Employers',
  TALENT_INVITATION = 'Talent Invitation',
  TALENT_INVITATIONS = 'Talent Invitations',
  TALENT_PROFILE = 'Talent Profile',
  TALENT_PROFILE_SUM = 'Talent Profile Summary',
  TALENT_PROVIDERS = 'Talent Providers',
  TALENT_SAVED_JOBS = 'Talent Saved Jobs',
  TALENT_SEARCH = 'Talent Search',
  TALENT_TRANSACTIONS = 'Talent Transactions',
}

export const getPageTitle = (path: string): string => {
  const clearedPath = path.indexOf('/[') === -1 ? path : path.split('/[')[0];

  const key =
    findKey(PathNames, (value: string) => {
      return value === clearedPath;
    }) || 'HOMEPAGE';

  const title =
    key === 'HOMEPAGE'
      ? MAIN_PAGE_TITLE
      : `${PageTitles[key as keyof typeof PageTitles]} | ${MAIN_PAGE_TITLE}`;

  return title;
};
